import { Component } from '@angular/core';
import { SkeletonComponent } from '@esolutions/design-system-ng/components';

@Component({
  selector: 'app-featured-placeholder',
  templateUrl: './featured-placeholder.component.html',
  styleUrls: ['./featured-placeholder.component.scss'],
  imports: [SkeletonComponent],
  standalone: true
})
export class FeaturedPlaceholderComponent {}
